// This is a component instead of a hook to make it possible to use it in App.tsx
// as it needs to be used inside the AuthProvider to have access to the user info

import { useEffect } from 'react';

import { usePostHog } from 'posthog-js/react';

import { useGetUserMe } from '@/api/REST/userMe';
import { useLocaleStore } from '@/stores/locale';

export const PostHogUserProperties = () => {
  const posthog = usePostHog();
  const { data: user } = useGetUserMe();
  const { lang: currentLang } = useLocaleStore();

  useEffect(() => {
    if (posthog && user?.billingPlan) {
      posthog.setPersonProperties({
        billingPlan: user.billingPlan.name,
        isLegacyBillingPlan: user.billingPlan.isLegacy,
      });
    }
  }, [user?.billingPlan]);

  useEffect(() => {
    if (posthog && user?.permittedPages) {
      posthog.setPersonProperties({
        resourcePlanner: user.permittedPages.some(
          (page) => page.pageIdentifier === 'NewResourcePlanner',
        ),
      });
    }
  }, [user?.permittedPages]);

  // Update posthog user with language when available
  useEffect(() => {
    if (posthog && currentLang) {
      posthog.setPersonProperties({ userLanguage: currentLang });
    }
  }, [currentLang]);

  return null;
};
